import {moment} from 'external/moment'

export const defaultDates = {
  month: (date) => ({
    start: moment(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
    end: moment(date).endOf('month').endOf('week').format('YYYY-MM-DD')
  }),
  week: (date) => ({
    start: moment(date).startOf('week').format('YYYY-MM-DD'),
    end: moment(date).endOf('week').format('YYYY-MM-DD')
  }),
  day: (date) => ({
    start: moment(date).format('YYYY-MM-DD'),
    end: moment(date).format('YYYY-MM-DD')
  })
}

export function newPlan(context, suggestedDate, suggestedGroup) {
    const planType = getPlanType(context)
    context.setState({newPlanFrom: 'month', newPlanFromQuery: {...context.query}, suggestedDate, suggestedGroup}, () => {
        context.navigate({}, `/:languageId/:role/:page/${planType}`)
    })
}

export function planLink(context, planId, defaultDate, prefix) {
    const planType = getPlanType(context, prefix)
    const newPlanFromQuery = {...(defaultDates[context.view] || defaultDates.week)(defaultDate()), group: context.query.group}
    context.setState({newPlanFrom: context.view, newPlanFromQuery})
    context.navigate({planId}, `/:languageId/:role/:page/${planType}/:planId`)
}

function getPlanType(context, prefix = 'plan') {
  const suffixIndex = context.page.indexOf('-')
  return suffixIndex < 0
    ? prefix
    : `${prefix}${context.page.substring(suffixIndex)}`
}